@if (showSpinner) {
  <div class="spinner">
    <mat-spinner mode="indeterminate"></mat-spinner>
  </div>
}
@if (showSpinner == false && (statusIsValid && loginStatus)) {
  <div class="twocp__container">
    <iframe  class="e2e-iframe-trusted-src" [src]="paymentPortalURL"></iframe>
  </div>
}
